import { render, staticRenderFns } from "./ZoomCard.vue?vue&type=template&id=c8492050&scoped=true&lang=pug"
import script from "./ZoomCard.vue?vue&type=script&lang=js"
export * from "./ZoomCard.vue?vue&type=script&lang=js"
import style0 from "./ZoomCard.vue?vue&type=style&index=0&id=c8492050&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8492050",
  null
  
)

export default component.exports